/* istanbul ignore file */
import GuarantorsForm from './GuarantorsForm';

export default GuarantorsForm;
